import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';


import TrackListView from '../components/trackView/TrackListView';
import TrackViewTop from '../components/trackView/TrackViewTop';
import TrackTimeLineView from '../components/trackView/TrackTimeLineView';
import TrackPlayer from '../components/trackView/TrackPlayer';

import { bottomViewSelector, trackDetailViewSelector, setTrackDetailView, setTimeLineView, setbottomView, trackDataSelector } from '../features/datacenter/historySlice';
import {
    setMapControl,
    setZoom,
    toggleVehicleIcons,
    setNeedBounding,
    clearGensetViewportPadding,
    setGensetFocusAssetId,
    setGensetTrackReportId,
} from '../features/map/mapSlice';
import { clearVisibleAssetsMarkers, restoreVisibleAssetsMarkers, removeDetailView } from '../features/assets/assetsSlice';
import { liveTrackinglayoutSelector } from '../features/layout/layoutSlice';

const TrackView = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const dimentions = useSelector(liveTrackinglayoutSelector);
    const bottomView = useSelector(bottomViewSelector);
    const trackDetailView = useSelector(trackDetailViewSelector);
    const trackData = useSelector(trackDataSelector);

    useEffect(() => {
        dispatch(setMapControl('track'));
        dispatch(removeDetailView());
        dispatch(clearVisibleAssetsMarkers());
        dispatch(toggleVehicleIcons(false));
        dispatch(setZoom(10));
        dispatch(clearGensetViewportPadding());
        dispatch(setGensetFocusAssetId(null));
        dispatch(setGensetTrackReportId(null));
        return () => {
            dispatch(setTrackDetailView(null));
            dispatch(setMapControl('asset'));
            dispatch(restoreVisibleAssetsMarkers());
            dispatch(toggleVehicleIcons(true));
        }
    }, [dispatch]);

    useEffect(() => {
        const reportID = location?.state?.reportID;
        if (!reportID) return;
        const entry = trackData?.[reportID];
        if (!entry?.track || !entry?.dataTable) return;
        dispatch(setTimeLineView(reportID));
        dispatch(setbottomView('summary'));
        dispatch(setTrackDetailView(reportID));
        dispatch(setNeedBounding(true));
        history.replace({ ...location, state: {} });
    }, [dispatch, history, location, trackData]);

    return (
        <div style={dimentions.sidebar}>
            <div style={dimentions.trackViewTop}>
                <TrackViewTop />
            </div>
            {
                bottomView === 'trackList' ?
                    <div style={{ ...dimentions.trackViewBottom, overflow: 'auto' }}>
                        <TrackListView />
                    </div>
                    :
                    <div style={{ ...dimentions.trackViewBottom, overflow: 'auto' }}>
                        <TrackTimeLineView />
                    </div>
            }
            {
                trackDetailView &&
                <div style={dimentions.trackPlayer}>
                    <TrackPlayer reportID={trackDetailView} />
                </div>
            }
        </div>
    );
}

export default TrackView;
